import {AuthService, Auth} from './auth';
import {useService} from '..';

export function useAuth(): Auth {
  return useService(AuthService);
}
